require('./insurancesListCardHeader.scss');

// @ vendor
const React = require('react');
const PropTypes = require('prop-types');
const classnames = require('classnames');

const InsurancesListCardHeader = props => {
    const { icon, title, amount, expanded } = props;

    const titleClasses = classnames('insurances-list-card-header__title-text', {
        'insurances-list-card-header__title-text--is-expanded': expanded
    });

    const classNameHeaderTitle = classnames(
        'insurances-list-card-header__title-icon',
        'icon',
        icon
    );

    const amountEl = amount ? (
        <span className="insurances-list-card-header__title-amount-items">
            ({amount})
        </span>
    ) : null;

    return (
        <div className="container-fluid">
            <div className="insurances-list-card-header row">
                <div className="col-xs-12 col-sm-6">
                    <div className="insurances-list-card-header__title-container">
                        <i className={classNameHeaderTitle}></i>
                        <span className={titleClasses}>
                            {title}
                        </span>
                        {amountEl}
                    </div>
                </div>
            </div>
        </div>
    );
};

InsurancesListCardHeader.propTypes = {
    icon: PropTypes.string,
    title: PropTypes.string,
    expanded: PropTypes.bool,
    amount: PropTypes.number
};

module.exports = InsurancesListCardHeader;